/**
 *  slideTo correct slide index on color swatch selection
 *  - gallery (carousel/slider)
 */
function slideOnSwatchSelection(gallery) {
  /**
   *  Listen to variant:change event (color swatch click)
   *  - slide to correct instance depending on variant fetaured media position
   * */
  document.addEventListener('variant:change', (e) => {
    // Determine index case 1 (has variant image): Get position from featured_media.position
    const mediaPosition = e.detail?.variant?.featured_media.position;
    const positionFeaturedMedia = mediaPosition - 1;

    // Determine index case 2 (no variant image): Filter all slides and find matches between option value and thumbnail file name
    const swatchName = e.detail.value
      .toLowerCase()
      .normalize('NFD')
      .replace(' ', '')
      .replace(/[\u0300-\u036f]/g, '');

    const positionColorNameMatch = gallery?.slides.filter((slide) =>
      slide?.thumbSrc?.includes(swatchName)
    )[0]?.index;

    // Determine final position index and call .slideTo method
    const position = positionFeaturedMedia || positionColorNameMatch;
    gallery?.slideTo(position);
  });
}

/**
 * Initialize Fancybox library for zooming PDP images
 */
const initProdGridZoom = () => {
  const isDesktop = window.matchMedia('(min-width: 769px)').matches;
  const gallery = isDesktop
    ? '[data-fancybox="gallery--desktop"]'
    : '[data-fancybox="gallery--mobile"]';

  if (!gallery) return;

  window.Fancybox.bind(gallery, {
    Thumbs: {
      type: 'classic',
    },
  });
};

/**
 * Initialize FancyApps Carousel for PDP gallery
 */
const initProdCarousel = () => {
  let carousel;
  const isDesktop = window.matchMedia('(min-width: 769px)').matches;
  const mobileCarouselEl = document?.querySelector('#sl-product-carousel--mobile');
  const desktopCarouselEl = document?.querySelector('#sl-product-carousel--desktop');
  const gallery = isDesktop
    ? '[data-fancybox="gallery--desktop"]'
    : '[data-fancybox="gallery--mobile"]';
  const carouselOptions = {
    transition: 'slide',
    preload: 1,
    breakpoints: {},
  };

  if (mobileCarouselEl) {
    // eslint-disable-next-line no-new
    carousel = new window.Carousel(mobileCarouselEl, carouselOptions);
    slideOnSwatchSelection(carousel);
  }

  if (desktopCarouselEl) {
    // eslint-disable-next-line no-new
    carousel = new window.Carousel(desktopCarouselEl, carouselOptions);
    slideOnSwatchSelection(carousel);
  }
  // Zoom functionality
  window.Fancybox.bind(gallery, {
    Thumbs: {
      type: 'classic',
    },
  });
};

/**
 * Initialize FancyApps Slider for PDP gallery
 */
const initProdSlider = () => {
  let slider;
  const isDesktop = window.matchMedia('(min-width: 769px)').matches;
  const mobileSliderEl = document?.querySelector('#sl-product-slider--mobile');
  const desktopSliderEl = document?.querySelector('#sl-product-slider--desktop');
  const gallery = isDesktop
    ? '[data-fancybox="gallery--desktop"]'
    : '[data-fancybox="gallery--mobile"]';

  const options = {
    transition: 'slide',
    Navigation: false,
    Dots: false,
    Thumbs: {
      type: 'classic',
      Carousel: {
        center: (mobileSliderEl || desktopSliderEl)?.childElementCount >= 4,
        fill: true,
        dragFree: true,
      },
    },
  };

  if (mobileSliderEl) {
    // eslint-disable-next-line no-new
    slider = new window.Carousel(mobileSliderEl, options, {Thumbs});
    slideOnSwatchSelection(slider);
  }

  if (desktopSliderEl) {
    // eslint-disable-next-line no-new
    slider = new window.Carousel(desktopSliderEl, options, {Thumbs});
    slideOnSwatchSelection(slider);
  }

  // Zoom functionality
  window.Fancybox.bind(gallery, {
    idle: false,
    compact: false,
    dragToClose: false,

    animated: false,
    showClass: 'f-fadeSlowIn',
    hideClass: false,

    Carousel: {
      infinite: false,
    },

    Images: {
      zoom: false,
      Panzoom: {
        maxScale: 1.5,
      },
    },

    Toolbar: {
      absolute: true,
      display: {
        left: [],
        middle: [],
        right: ['close'],
      },
    },

    Thumbs: {
      type: 'classic',
      Carousel: {
        axis: 'x',

        slidesPerPage: 1,
        Navigation: true,
        center: true,
        fill: true,
        dragFree: true,

        breakpoints: {
          '(min-width: 640px)': {
            axis: 'y',
          },
        },
      },
    },
  });
};

/**
 * Product back button
 */
const getBackUrl = () => {
  const backButton = document?.querySelector('#sl-back');
  if (!backButton) return;

  const backUrl = backButton?.dataset.url;
  const lastViewed = document.referrer;
  backButton.addEventListener('click', () => {
    if (lastViewed?.includes(window.location.host)) {
      window.history.back();
    } else {
      window.location.href = backUrl;
    }
  });
};

function scrollToReviews() {
  const reviewBadge = document.querySelector('.sl-product-form .jdgm-prev-badge');
  if (!reviewBadge) return;

  const productReviewsSection = document.getElementById('product-reviews');
  if (!productReviewsSection) return;

  reviewBadge.addEventListener('click', () => {
    productReviewsSection.scrollIntoView({behavior: 'smooth', block: 'center'});
  });
}

document.addEventListener('DOMContentLoaded', () => {
  getBackUrl();
  initProdGridZoom();
  initProdCarousel();
  initProdSlider();
  scrollToReviews();
});
